import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import StepOne from './Steps/StepOne';
import StepTwo from './Steps/StepTwo';
import StepThree from './Steps/StepThree';
import './style.scss';
import { OTPContext } from './context/index';

// This will be used to reset the error state
const initialError = [
  {
    status: false,
    msg: '',
  },
  {
    status: false,
    msg: '',
  },
  {
    status: false,
    msg: '',
  },
];

const IBANGeneratorComponent = ({ fields = {}, params, t }) => {
  // Destructuring props
  let {
    verificationCodeExpiredErrorMessage,
    buttonText,
    description,
    endPoint,
    inputLabel,
    inputNote,
    inputPlaceholder,
    maxLength,
    resultButtonText,
    resultDescription,
    resultIcon,
    resultIconTooltip,
    resultLabel,
    title,
    emptyMessage,
    lengthMessage,
    generalErrorMessage,
    otpLabel,
    otpButton,
    otpHeading,
    otpSubHeading,
    otpDidNotReceiveText,
    otpSendNewCodeText,
    otpVerificationCode,
    timeout,
    otpGenerateEndpoint,
    otpVerifyEndpoint,
    limitationNumber,
    limitationMessage,
    otpGenerateErrorMessage,
    otpRegenerateWaitingTime,
    timeoutErrorMessage,
  } = fields;

  // Component states
  const [step, setStep] = useState(0);
  const [error, setError] = useState(initialError);
  const [accountNumber, setAccountNumber] = useState('');
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [ibanNumber, setIbanNumber] = useState('');

  const providerValue = { ibanNumber, setIbanNumber };
  // Each step component props
  const stepOneProps = {
    error,
    setError,
    initialError,
    setStep,
    ibanNumber,
    setIbanNumber,
    recaptchaValue,
    setRecaptchaValue,
    accountNumber,
    setAccountNumber,
    title,
    description,
    inputLabel,
    inputNote,
    inputPlaceholder,
    maxLength,
    otpButton,
    otpGenerateEndpoint,
    otpGenerateErrorMessage,
    otpRegenerateWaitingTime,
    limitationNumber,
    generalErrorMessage,
    limitationMessage,
    timeoutErrorMessage,
    timeout,
  };
  const stepTwoProps = {
    verificationCodeExpiredErrorMessage,
    error,
    setError,
    initialError,
    setStep,
    ibanNumber,
    recaptchaValue,
    setRecaptchaValue,
    title,
    otpSubHeading,
    otpVerificationCode,
    otpDidNotReceiveText,
    otpSendNewCodeText,
    accountNumber,
    t,
    timeout,
    otpVerifyEndpoint,
    otpGenerateEndpoint,
    generalErrorMessage,
    limitationNumber,
    limitationMessage,
    otpGenerateErrorMessage,
    timeoutErrorMessage,
  };
  const stepThreeProps = {
    setError,
    initialError,
    setStep,
    ibanNumber,
    setIbanNumber,
    recaptchaValue,
    setRecaptchaValue,
    accountNumber,
    setAccountNumber,
    title,
    description,
    inputLabel,
    inputNote,
    resultButtonText,
    resultDescription,
    resultIcon,
    resultIconTooltip,
    resultLabel,
    endPoint,
  };

  // We will render each component based on the step
  const renderStep = () => {
    switch (step) {
      case 0:
        return <StepOne {...stepOneProps} />;
      case 1:
        return <StepTwo {...stepTwoProps} />;
      case 2:
        return <StepThree {...stepThreeProps} />;
      default:
        return <StepOne {...stepOneProps} />;
    }
  };

  return (
    <OTPContext.Provider value={providerValue}>
      <div className={clsx('iban-generator-recaptcha', 'add-margins', params?.Styles)}>
        <div className="iban-generator-container content">{renderStep()}</div>
      </div>
    </OTPContext.Provider>
  );
};

export default withTranslation()(IBANGeneratorComponent);
